import { render, staticRenderFns } from "./WarningBar.vue?vue&type=template&id=283bdee3&scoped=true"
import script from "./WarningBar.vue?vue&type=script&lang=js"
export * from "./WarningBar.vue?vue&type=script&lang=js"
import style0 from "./WarningBar.vue?vue&type=style&index=0&id=283bdee3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bdee3",
  null
  
)

export default component.exports